export default __webpack_public_path__ + "743324f8e09d34a894c21e91c396f289.svg";